import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H3 = (props: Props) => {
    return (
        <H3WithStyled { ...props }>
            { props.children }
        </H3WithStyled>
    );
};

const H3WithStyled = styled.h3`
    padding: 0.3em 0.5em;
    color: #494949;
    background: #f4f4f4;
    border-left: solid 5px #7db4e6;
    border-bottom: solid 3px #d7d7d7;
`

export default H3;